import { render } from "./AttachmentsModal.vue?vue&type=template&id=523fad49&scoped=true"
import script from "./AttachmentsModal.vue?vue&type=script&lang=js"
export * from "./AttachmentsModal.vue?vue&type=script&lang=js"

import "./AttachmentsModal.vue?vue&type=style&index=0&id=523fad49&scoped=true&lang=scss"

import exportComponent from "/var/www/driveapp2.locatiers.fr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-523fad49"]])

export default __exports__